import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "absolute inset-0 z-20 bg-background" }
const _hoisted_2 = { class: "absolute top-0 right-0 pt-2.5 pr-2.5 z-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", { class: "icon stroke-2 w-4 h-4 text-primary opacity-40 transition hover:opacity-100" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#close" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "relative h-full flex flex-col justify-center gap-2.5 px-10"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-center text-primary/60 leading-none hidden xs:block" }, "Copy embed code:", -1)
const _hoisted_7 = { class: "flex justify-center" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 2,
  class: "embed-button embed-button--small-share embed-button--secondary pointer-events-none"
}
const _hoisted_11 = {
  key: 1,
  class: "relative h-full flex flex-col justify-center gap-2.5 px-10"
}
const _hoisted_12 = {
  key: 0,
  class: "flex items-center justify-center h-8 bg-primary/05 rounded-full font-bold text-sm text-primary"
}
const _hoisted_13 = {
  key: 1,
  class: "flex justify-center gap-[5px]"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "share-item__button" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#twitter" })
  ])
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"share-item__button\"><svg class=\"icon\" viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 35.8C6.5 34.3 0 26.9 0 18C0 8.1 8.1 0 18 0C27.9 0 36 8.1 36 18C36 26.9 29.5 34.3 21 35.8L20 35H16L15 35.8Z\" fill=\"url(#paint0_linear_146_8342)\" stroke-width=\"0\"></path><path d=\"M20.4444 17.9999V18.5555H21H25.1485L24.5263 22.4444H21H20.4444V22.9999V35.2376C19.6288 35.3756 18.8141 35.4444 18 35.4444C17.1859 35.4444 16.3712 35.3756 15.5556 35.2376V22.9999V22.4444H15H11.0556V18.5555H15H15.5556V17.9999V13.9999C15.5556 11.8733 16.2375 10.2781 17.3472 9.21329C18.4606 8.14488 20.0619 7.55549 22 7.55549C23.1018 7.55549 24.2877 7.70504 25.4444 7.87754V11.4444H23.7C22.5164 11.4444 21.6565 11.7408 21.1098 12.3558C20.5742 12.9584 20.4444 13.7522 20.4444 14.4999V17.9999Z\" fill=\"white\" stroke=\"white\" stroke-width=\"1.11111\"></path><defs><linearGradient id=\"paint0_linear_146_8342\" x1=\"18\" y1=\"34.754\" x2=\"18\" y2=\"0\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#0062E0\"></stop><stop offset=\"1\" stop-color=\"#19AFFF\"></stop></linearGradient></defs></svg></div>", 1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "share-item__button" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#whatsapp" })
  ])
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "share-item__button share-item__button--icon" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#embed" })
  ])
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["href", "download"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "share-item__button share-item__button--icon" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#download" })
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "share-item__button share-item__button--icon" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#mail" })
  ])
], -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "share-item__button share-item__button--icon" }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("svg", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#copy" })
], -1)
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "share-item__button share-item__button--icon" }
const _hoisted_36 = ["value"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("svg", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#link" })
], -1)
const _hoisted_38 = { class: "flex items-center justify-center" }
const _hoisted_39 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        role: "button",
        tabindex: "0",
        class: "inline-flex",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideShareOverlay && _ctx.hideShareOverlay(...args)), ["stop","prevent"]))
      }, _hoisted_4)
    ]),
    (_ctx.showEmbedShare)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.embedCopied)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  role: "button",
                  tabindex: "0",
                  class: "embed-button embed-button--small-share embed-button--primary mx-0.5",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyImmersive && _ctx.copyImmersive(...args)), ["stop","prevent"]))
                }, [
                  _createElementVNode("input", {
                    ref: "immersiveCode",
                    type: "hidden",
                    value: _ctx.immersiveCode
                  }, null, 8, _hoisted_8),
                  _createTextVNode(" Large ")
                ]))
              : _createCommentVNode("", true),
            (!_ctx.embedCopied)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  role: "button",
                  tabindex: "0",
                  class: "embed-button embed-button--small-share embed-button--primary mx-0.5",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyMini && _ctx.copyMini(...args)), ["stop","prevent"]))
                }, [
                  _createElementVNode("input", {
                    ref: "miniCode",
                    type: "hidden",
                    value: _ctx.miniCode
                  }, null, 8, _hoisted_9),
                  _createTextVNode(" Small ")
                ]))
              : _createCommentVNode("", true),
            (_ctx.embedCopied)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Code copied"))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.linkCopied)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Link copied"))
            : _createCommentVNode("", true),
          (!_ctx.linkCopied)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("a", {
                  class: "share-item share-item--small",
                  href: `https://twitter.com/intent/tweet?text=${_ctx.encodedShareURL}`,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackShareClick('twitter'))),
                  target: "_blank",
                  rel: "noopener nofollow"
                }, _hoisted_16, 8, _hoisted_14),
                _createElementVNode("a", {
                  class: "share-item share-item--small",
                  href: `https://www.facebook.com/sharer/sharer.php?u=${_ctx.encodedShareURL}`,
                  target: "_blank",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trackShareClick('facebook'))),
                  rel: "noopener nofollow"
                }, _hoisted_19, 8, _hoisted_17),
                _createElementVNode("a", {
                  class: "share-item share-item--small",
                  href: `whatsapp://send?text=${_ctx.encodedShareURL}`,
                  target: "_blank",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.trackShareClick('whatsapp'))),
                  rel: "noopener nofollow"
                }, _hoisted_22, 8, _hoisted_20),
                _createElementVNode("div", {
                  role: "button",
                  tabindex: "0",
                  class: "share-item share-item--small",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEmbedClick && _ctx.onEmbedClick(...args)), ["stop","prevent"]))
                }, _hoisted_24),
                (_ctx.shareVideoUrl && _ctx.isPostShare)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "share-item share-item--small",
                      href: _ctx.shareVideoUrl,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.trackShareClick('downloadVideo'))),
                      download: _ctx.shareVideoUrl,
                      target: "_blank"
                    }, _hoisted_27, 8, _hoisted_25))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  class: "share-item share-item--small",
                  href: `mailto:?body=${_ctx.encodedShareURL}`,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.trackShareClick('email')))
                }, _hoisted_30, 8, _hoisted_28),
                _createElementVNode("div", {
                  role: "button",
                  tabindex: "0",
                  class: "share-item share-item--small",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCopyLink && _ctx.onCopyLink(...args)), ["stop","prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("input", {
                      ref: "shareUrl",
                      type: "hidden",
                      value: _ctx.shareURL
                    }, null, 8, _hoisted_32),
                    _hoisted_33
                  ])
                ]),
                (_ctx.post?.link && _ctx.showLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "share-item share-item--small",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.trackShareClick('postLink'))),
                      href: _ctx.post.link.url,
                      rel: "nofollow noopener",
                      target: "_blank"
                    }, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("input", {
                          ref: "shareUrl",
                          type: "hidden",
                          value: _ctx.shareURL
                        }, null, 8, _hoisted_36),
                        _hoisted_37
                      ])
                    ], 8, _hoisted_34))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("a", {
              href: _ctx.portalShareURL,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.trackClickOut('mainLogo'))),
              rel: "nofollow noopener",
              target: "_blank",
              class: "text-primary/60 transition hover:text-primary text-[10px] leading-3"
            }, "Powered by Beams.fm", 8, _hoisted_39)
          ])
        ]))
  ]))
}